import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { SafeNumberPipe } from '@app/shared/pipes/safe-number/safe-number.pipe';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'app-project-completion-fluid',
  templateUrl: './project-completion-fluid.component.html',
  styleUrls: ['./project-completion-fluid.component.scss'],
  imports: [
    NumericTextBoxComponent,
    ReactiveFormsModule,
    SafeNumberPipe,
    SVGIconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    DecimalPipe, //Needed for SafeNumberPipe
  ],
})
export class ProjectCompletionFluidComponent {
  readonly fluidData = input<any>(undefined);
  readonly fluidForm = input<any>(undefined);
  readonly tooltipClick = output<any>();
  public icons = kendoIcons;

  onClickTooltipIcon() {
    this.tooltipClick.emit(null);
  }
}